///
/// EarthBrowser
///
/// Created by Matt Giger on 8/23/2024
/// Copyright (c) 2024 Geodata Labs
///

import { StovokorContext } from "@stovokor/StovokorContext"

export class RenderBuffer {
	public width: number
	public height: number
	public internalFormat: GLenum
	public bufferId: WebGLRenderbuffer | null = null
	private context: StovokorContext

	constructor(context: StovokorContext, width: number, height: number, internalFormat: GLenum) {
		this.context = context
		this.width = width
		this.height = height
		this.internalFormat = internalFormat
		this.bufferId = context.gl.createRenderbuffer()
		context.gl.bindRenderbuffer(WebGL2RenderingContext.RENDERBUFFER, this.bufferId)
		context.gl.renderbufferStorage(WebGL2RenderingContext.RENDERBUFFER, internalFormat, width, height)
		context.gl.bindRenderbuffer(WebGL2RenderingContext.RENDERBUFFER, null)
	}

	public bind() {
		this.context.gl.bindRenderbuffer(WebGL2RenderingContext.RENDERBUFFER, this.bufferId)
	}

	public unbind() {
		this.context.gl.bindRenderbuffer(WebGL2RenderingContext.RENDERBUFFER, null)
	}
}
